import { getSafe } from "./util/storeHelper";
class ReduxProp {
    mInputs;
    mFunc;
    mApi;
    mSubscribers;
    mUnsubscribe;
    constructor(api, inputs, func) {
        this.mInputs = inputs;
        this.mFunc = func;
        this.mApi = api;
        this.mSubscribers = [];
    }
    attach(component) {
        if (this.mSubscribers.length === 0) {
            this.subscribe();
        }
        this.mSubscribers.push(component);
    }
    detach(component) {
        const idx = this.mSubscribers.indexOf(component);
        this.mSubscribers.splice(idx, 1);
        if (this.mSubscribers.length === 0) {
            this.unsubscribe();
        }
    }
    calculate() {
        if (!this.mApi) {
            return undefined;
        }
        const values = this.mInputs.map((valPath) => getSafe(this.mApi.getState(), valPath, undefined));
        return this.mFunc(...values);
    }
    subscribe() {
        if (!this.mApi) {
            return;
        }
        let oldState = this.mApi.getState();
        this.mUnsubscribe = this.mApi.store.subscribe(() => {
            const changed = this.mInputs.find((valPath) => getSafe(oldState, valPath, undefined) !==
                getSafe(this.mApi.getState(), valPath, undefined));
            oldState = this.mApi.getState();
            if (changed !== undefined) {
                this.mSubscribers.forEach((sub) => sub.forceUpdate());
            }
        });
    }
    unsubscribe() {
        this.mUnsubscribe();
        this.mUnsubscribe = undefined;
    }
}
export default ReduxProp;
